import React, { useState, createContext } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';

import { SideBarModal } from '../../components';
import {
  StyledWrapper,
  StyledWrapperLeft,
  StyledWrapperRight,
  StyledButtonSidebar,
} from './SideBarLayout.styled';

export const SideBarContext = createContext();

const SideBarLayout = props => {
  const {sideBar, children} = props;
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  }

  const handleOpen = () => {
    setOpen(true);
  }

  return (
    <SideBarContext.Provider value={{ handleClose }}>
      <StyledWrapper>
        <Grid
          container
          direction="row"
        >
          <Grid item xs={3}>
            <StyledWrapperLeft>
              {
                sideBar
              }
            </StyledWrapperLeft>
          </Grid>
          <Grid item xs={12} md={9}>
            <StyledWrapperRight>
              {children}
              <StyledButtonSidebar onClick={handleOpen}>
                <FormatListBulletedIcon size={24} />
              </StyledButtonSidebar>
            </StyledWrapperRight>
          </Grid>
        </Grid>
        <SideBarModal handleClose={handleClose} open={open}>{sideBar}</SideBarModal>
      </StyledWrapper>
    </SideBarContext.Provider>
  )
}

SideBarLayout.propTypes = {
  children: PropTypes.node,
}

export default SideBarLayout
